module.exports = __webpack_public_path__ + "img/character1.62f436ec.png";